import axios from "axios";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	Route,
	Switch,
	useHistory,
	useParams,
	useRouteMatch
} from "react-router-dom";
import { getDocsReq } from "../actions/getDocs";
import { loadRoutes } from "../actions/loadRoutes";
import { IP } from "../config/IP";
import store from "../store/createStore";
import "./Dashboard.css";
import DocProcessingScreen from "./DocProcessingScreen";
import { LeftSideScreen } from "./SideScreen";
import PrimarySearchAppBar from "./TopToolBar";

//import HomeEditingDoc from "./HomeEditingDoc";
//https://codepen.io/themustafaomar/pen/jLMPKm

//import HomeEditingDoc from "./HomeEditingDoc";
//https://codepen.io/themustafaomar/pen/jLMPKm
function DocumentScreen(props) {
	//console.log("IP.nodeServer=", IP.nodeServer + "api/getDocsAggregates");

	const history = useHistory();
	const notitifcationRef = useRef();
	const state = useSelector((state) => state);

	const dispatch = useDispatch();
	let match = useRouteMatch();
	let { type } = useParams();

	//start get docs
	{
	}
	//end of docs
	var buffer;
	let image;
	try {
		buffer = Buffer.from(store.getState().auth.user.image.data);
		image = "data:image/png;base64," + buffer.toString("base64");
	} catch (e) {}
	//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
	const [showscreen, setShowscreen] = React.useState();
	const [imageSrc, setImageSrc] = React.useState(image);
	let imageltvar;
	try {
		imageltvar = store
			.getState()
			.auth.user.allUser.find(
				(y) => y._id === store.getState().auth.user.usernameId
			).username;
	} catch (e) {}
	const [imageAlt, setImageAlt] = React.useState(imageltvar);
	const [username, setUsername] = React.useState(imageltvar);
	const [office_name, setOffice_name] = React.useState(imageltvar);
	const [screen, setScreen] = React.useState();
	const notificationRef = useRef(null);
	const [notification, setNotification] = React.useState([]);
	const token = localStorage.getItem("token");

	let item = [];
	const setNotificationFx = async (data) => {
		console.log("setNotificationFx in TopToolBar Data=", data);
		item = [];
		let photo = {};
		const config = {
			headers: {
				"x-auth-token": token,
				"content-type": "application/json",
			},
		};
		data.NotificationResp.docs.map(async (x, index) => {
			let username = state.auth.user.allUser.find(
				(y) => y._id === x.receiverUsernameId
			).username;
			let output = await axios.get(
				IP.nodeServer + "api/profileimage/" + username,
				config
			);
			//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
			console.log("return output=", output);
			if (output) {
				try {
					var buffer = Buffer.from(output.data.image.picture.data).toString(
						"base64"
					);
					photo = "data:image/png;base64," + buffer.toString(buffer);
				} catch (e) {
					photo = "person.png";
				}
				item.push({
					key: x._id,
					id: x.docId,
					createDate: x.createDate,
					readstatus: x.readstatus,
					readstatusDate: x.readstatusDate,
					username: username,
					message: x.message,
					photo: photo,
				});
				//if (item.length===index)
				console.log("index =", index);
				console.log("item =", item.length);
				if (index === item.length) {
					//notificationRef.current.putItems(item);
					setNotification(item);
					console.log("TopToolBar item=", item);
				}
			}
		});
	};
	const setnewProfilePicture = (value) => {
		if (value) {
			console.log("DocumentScreen USEEffect setnewProfilePicture issued");
			var buffer = Buffer.from(store.getState().userStatus.image.data);
			setImageSrc("data:image/png;base64," + buffer.toString("base64"));
		}
	};

	useEffect(() => {
		try {
			console.log("DocumentScreen props.state=", props.state);
			//props.resetDocForm();
			let inputs = {
				url: IP.nodeServer + "api/routesRules",
				method: "POST",
				data: [{ name: "Doc_type_id", value: parseInt(1) }],
			};
			dispatch(loadRoutes(inputs));
			if (!state.loadRoutes.isLaoded) props.loadRoutes(inputs);
			let actingOffices = {};
			let assistant_offices=[];
			try {
				actingOffices = state.userStatus.status.actingOffice
					.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
					.map((x) => x.officeActingOnBehalf);
				console.log("DashboardScreen real actingOffices=", actingOffices);
			} catch (e) {}
			try{
			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}

			if (state.companyData.selectedCompanyId) {
				inputs = {
					url: IP.nodeServer + "api/getDocs",
					method: "POST",
					office_id: state.auth.user.office[0].office_id,
					companyId: state.companyData.selectedCompanyId,
					actingOffices: actingOffices,
					assistant_offices:assistant_offices,
					page: 1,
					limit: 5,
					action: null,
				};
				console.log("DocumentScreen USEEffect  clicked inputs=", inputs);
				dispatch(getDocsReq(inputs));
			}

			if (!showscreen) setShowscreen(<DocProcessingScreen showSearch={true} />);
			console.log("DocumentScreen USEEffect clicked");
		} catch (e) {
			console.log("DocumentScreen Error=", e);
		}
	}, [showscreen, setShowscreen]);
	const showDraftDocs = () => {
		//setShowscreen(<DocProcessingScreen showSearch={true} />);
		history.push("/document/draft");
	};
	const showTrashDocs = () => {
		//setShowscreen(<DocProcessingScreen showSearch={true} />);
		history.push("/document/trash");
	};
	const showAllDocs = () => {
		//setShowscreen(<DocProcessingScreen showSearch={true} />);
		history.push("/document/all");
	};

	React.useEffect(() => {
		setShowscreen(<DocProcessingScreen showSearch={true} />);
	}, [type]);

	return (
		<div className="container">
			<LeftSideScreen
				showAllDocs={showAllDocs}
				showDraftDocs={showDraftDocs}
				showTrashDocs={showTrashDocs}
				imageSrc={imageSrc}
				imageAlt={imageAlt}
				office_name={office_name}
				username={username}
				setnewProfilePicture={setnewProfilePicture}
			/>

			<section id="contents">
				<PrimarySearchAppBar ref={notitifcationRef} item={notification} />
				<Switch>
					<Route path={`${match.path}/docId/:docId`}>
						<Doc />
					</Route>
					<Route path={`${match.path}/:type`}>{showscreen}</Route>

					<Route path={match.path}>{showscreen}</Route>
				</Switch>
			</section>
		</div>
	);
}

function Doc(props) {
	const [showscreen, setShowscreen] = React.useState();
	let { docId } = useParams();
	const dispatch = useDispatch();
	const state = useSelector((state) => state);
	console.log("Doc props=", state);

	useEffect(() => {
		if (docId) {
			try {
				//props.resetDocForm();
				let inputs = {
					url: IP.nodeServer + "api/routesRules",
					method: "POST",
					data: [{ name: "Doc_type_id", value: parseInt(1) }],
				};
				dispatch(loadRoutes(inputs));

				setShowscreen(
					<DocProcessingScreen filterDocId={docId} showSearch={false} />
				);
				console.log("DocumentScreen USEEffect clicked");
			} catch (e) {
				console.log("DocumentScreen Error=", e);
			}
		}
	}, [docId]);

	return <>{showscreen}</>;
}

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(DocumentScreen);
